import DownloadTicketButton from 'app/components/DownloadTicketButton/DownloadTicketButton';
import React from 'react';
import appleWalletIcon from 'assets/icons/add-to-apple-wallet.svg';

interface AddTicketToAppleWalletProps {
  link: string;
}

const AddTicketToAppleWallet: React.FC<AddTicketToAppleWalletProps> = ({
  link,
}) => {
  return (
    <DownloadTicketButton link={link} className="w-fit">
      <img
        src={appleWalletIcon}
        alt="Add to Apple Wallet"
        className="min-w-[111px]"
      />
    </DownloadTicketButton>
  );
};

export default AddTicketToAppleWallet;
